import { render } from "./information_block.vue?vue&type=template&id=62913e08&scoped=true"
import script from "./information_block.vue?vue&type=script&lang=js"
export * from "./information_block.vue?vue&type=script&lang=js"

import "./information_block.vue?vue&type=style&index=0&id=62913e08&scoped=true&lang=css"

import exportComponent from "C:\\Прогерство\\vue\\new_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62913e08"]])

export default __exports__